export default "__VITE_ASSET__S86OTuKd__"